import { useAuthStore } from '@/stores/auth'

export function useAuth() {
  const { token, isAuthenticated, mustChangePassword, setToken, clearToken, setMustChangePassword } =
    useAuthStore()

  return {
    token,
    isAuthenticated,
    mustChangePassword,
    setAuthToken: setToken,
    clearAuthToken: clearToken,
    setMustChangePassword,
  }
}
